<div class="bottom">
  <div class="left top">
    <img class="logo" [alt]="altText()" [src]="imgSrc()" [attr.width]="imgWidth()" [attr.height]="imgHeight()" />
  </div>
  <div class="right stack">
    <a
      class="imprint"
      target="_blank"
      rel="noopener noreferrer"
      [href]="prefixedImprintUrl()"
      aria-label="Impressum - öffnet in einem neuen Fenster"
      >Impressum</a
    >
    <a
      class="dataPrivacy"
      target="_blank"
      rel="noopener noreferrer"
      [href]="prefixedDataPrivacyUrl()"
      aria-label="Datenschutz - öffnet in einem neuen Fenster"
      >Datenschutz</a
    >
  </div>
</div>
